import React from 'react';

/**
 * Toast notification component
 * @param {Object} props - Component props
 * @param {boolean} props.visible - Whether the notification is visible
 * @param {string} props.message - The notification message
 * @returns {React.ReactElement|null} - The notification component or null
 */
const SaveNotification = ({ visible, message }) => {
  if (!visible) return null;
  
  return (
    <div 
      className="fixed bottom-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg transition-opacity"
      style={{ opacity: visible ? 1 : 0 }}
    >
      {message}
    </div>
  );
};

export default SaveNotification;